import { User } from './User.types';

export const missingValidRoles = (user: User | undefined) => {
    return (
        user &&
        !user?.role?.includes('guest') &&
        !user?.role?.includes('sds_user')
    );
};
